export default __webpack_public_path__ + "static/spet0-91175f05398d12a76d294f4e4da230aa.png";